<template>
  <div class="car-structure-container">
    <!-- (1) PageHeader -->
    <ds-page-header :title="$t('carStructure.page.title')" :subtitle="$t('carStructure.page.subtitle')" />

    <el-row :gutter="16">
      <el-col :xs="24" :sm="24" :md="6" :lg="5">
        <div class="ds-panel ds-role-tree">
          <floor-unit-tree ref="floorUnitTree" @switchFloorUnit="switchFloorUnit" />
        </div>
      </el-col>

      <el-col :xs="24" :sm="24" :md="18" :lg="19">
        <!-- (3)(4) Toolbar + CardGrid -->
        <div class="ds-panel">
          <ds-toolbar :total="carStructureInfo.cars.length" :density="density" :show-column-setting="false"
            :show-refresh="true" @update:density="density = $event" @refresh="refreshCars">
            <template #left>
              <span class="ds-panel__title">{{ $t('carStructure.page.listTitle') }}</span>
            </template>
          </ds-toolbar>

          <div v-loading="loading" class="car-grid-wrap">
            <el-row v-if="carStructureInfo.cars.length" :gutter="16" class="car-grid">
              <el-col v-for="(car, index) in carStructureInfo.cars" :key="index" :xs="12" :sm="8" :md="6" :lg="4"
                class="car-grid__cell">
                <div class="car-card" @dblclick="toSimplifyAcceptance(car)">
                  <div class="car-card__head">
                    <span class="ds-num car-card__space">{{ car.areaNum }}-{{ car.num }}</span>
                    <ds-status-tag size="sm" :type="resolveCarState(car).type" :label="resolveCarState(car).label" />
                  </div>
                  <div class="ds-num car-card__plate">{{ car.carNum || '-' }}</div>
                  <div class="car-card__room">{{ car.floorNum }}-{{ car.unitNum }}-{{ car.roomNum }}</div>
                  <div class="car-card__owner">{{ car.ownerName || $t('carStructure.noOwner') }}</div>
                  <div class="car-card__owe">
                    <span>{{ $t('carStructure.oweAmount') }}</span>
                    <span class="ds-num">{{ car.oweAmount || 0 }}</span>
                    <span>{{ $t('carStructure.yuan') }}</span>
                  </div>
                </div>
              </el-col>
            </el-row>
            <div v-else class="car-grid-empty">{{ $t('carStructure.page.empty') }}</div>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import floorUnitTree from '@/components/room/floorUnitTree'
import { listCarStructure } from '@/api/car/carStructureApi'
import { getCommunityId } from '@/api/community/communityApi'
import DsPageHeader from '@/components/ds/ds-page-header.vue'
import DsToolbar from '@/components/ds/ds-toolbar.vue'
import DsStatusTag from '@/components/ds/ds-status-tag.vue'

export default {
  name: 'CarStructureList',
  components: {
    floorUnitTree,
    DsPageHeader,
    DsToolbar,
    DsStatusTag
  },
  data() {
    return {
      loading: false,
      density: 'default',
      currentUnitId: '',
      carStructureInfo: {
        cars: []
      },
      communityId: ''
    }
  },
  created() {
    this.communityId = getCommunityId()
    setTimeout(() => {
      this.$refs.floorUnitTree.selectFirstUnit()
    }, 1000)
  },
  methods: {
    switchFloorUnit(data) {
      this.carStructureInfo.cars = []
      this.currentUnitId = ''
      if (!data.unitId) {
        return
      }
      this.currentUnitId = data.unitId
      this.loadCars(data.unitId)
    },
    refreshCars() {
      if (this.currentUnitId) {
        this.loadCars(this.currentUnitId)
      }
    },
    async loadCars(unitId) {
      this.loading = true
      try {
        const params = {
          page: 1,
          row: 100,
          unitId: unitId,
          communityId: this.communityId
        }
        const { data } = await listCarStructure(params)
        this.carStructureInfo.cars = data || []
      } catch (error) {
        this.$message.error(this.$t('carStructure.fetchError'))
      } finally {
        this.loading = false
      }
    },
    /**
     * 车辆状态语义映射：颜色仅作辅助，状态同时以文字表达（WCAG 1.4.1）
     */
    resolveCarState(car) {
      if (!car.ownerName) {
        return { type: 'info', label: this.$t('carStructure.state.noOwner') }
      }
      if (car.oweAmount > 0) {
        return { type: 'danger', label: this.$t('carStructure.state.arrears') }
      }
      return { type: 'success', label: this.$t('carStructure.state.normal') }
    },
    toSimplifyAcceptance(car) {
      this.$router.push('/pages/property/simplifyAcceptance?tab=业务受理&searchType=1&searchValue=' + `${car.floorNum}-${car.unitNum}-${car.roomNum}`)

    }
  }
}
</script>

<style lang="scss" scoped>
.car-structure-container {
  padding: var(--ds-spacing-lg);
  background-color: var(--ds-gray-100);
  min-height: calc(100vh - 60px);
}

.ds-panel {
  background: #fff;
  border: 1px solid var(--ds-gray-300);
  border-radius: var(--ds-radius-md);
  box-shadow: var(--ds-shadow-sm);
  overflow: hidden;
  margin-bottom: var(--ds-spacing-lg);

  &__title {
    font-size: var(--ds-font-size-lg);
    font-weight: 600;
    color: var(--ds-gray-800);
  }
}

.ds-role-tree {
  padding: var(--ds-spacing-md) 0;
}

.car-grid-wrap {
  min-height: calc(100vh - 260px);
  padding: var(--ds-spacing-lg);
}

.car-grid__cell {
  margin-bottom: var(--ds-spacing-lg);
}

.car-card {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: var(--ds-spacing-md);
  min-height: 118px;
  text-align: center;
  background: var(--ds-gray-100);
  border: 1px solid var(--ds-gray-300);
  border-left: 3px solid var(--ds-primary);
  border-radius: var(--ds-radius-md);
  cursor: pointer;
  transition: background-color var(--ds-transition-fast), box-shadow var(--ds-transition-fast);

  &:hover {
    background: var(--ds-primary-sub);
    box-shadow: var(--ds-shadow-sm);
  }

  &__head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: var(--ds-spacing-xs);
  }

  &__space {
    font-size: var(--ds-font-size-sm);
    font-weight: 600;
    color: var(--ds-gray-800);
  }

  &__plate {
    font-size: var(--ds-font-size-lg);
    font-weight: 600;
    color: var(--ds-gray-900);
  }

  &__room {
    font-size: var(--ds-font-size-xs);
    color: var(--ds-gray-500);
  }

  &__owner {
    font-size: var(--ds-font-size-sm);
    color: var(--ds-gray-700);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  &__owe {
    font-size: var(--ds-font-size-xs);
    color: var(--ds-gray-600);
  }
}

.car-grid-empty {
  padding: 60px 0;
  text-align: center;
  color: var(--ds-gray-500);
  font-size: var(--ds-font-size-sm);
}
</style>
